export default __webpack_public_path__ + "static/media/DSC02220.e643966f.jpeg";